import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import LoadingSpinner from 'jl-design-system/components/loading-spinner/LoadingSpinner';
import styles from './image-search.scss';

const ImageSearch = () => {
  const formEl = useRef(null);
  const [uploading, setUploading] = useState(false);

  const checkFileSize = file => {
    if (file && file.size && file.size < 10000000) {
      return true;
    }
    // eslint-disable-next-line no-alert
    window.alert(
      'Image too large, Make sure your image is not larger than 10mb.'
    );
    return false;
  };

  const checkIfImage = file => {
    const filetype = file?.type.substring(0, 6);
    if (filetype === 'image/') {
      return true;
    }
    // eslint-disable-next-line no-alert
    window.alert(
      'Wrong image format, we can only accept .jpg, .jpeg, .jpe, .png, .bmp, .dib, .webp, .pbm, .pmm, .sr, .ras, .tiff, .tif'
    );
    return false;
  };

  /* eslint-disable consistent-return */
  const uploadImage = e => {
    try {
      setUploading(true);
      const file = e.target.files[0];
      if (!file) {
        setUploading(false);
        // eslint-disable-next-line no-alert
        window.alert('Please select an image');
        return false;
      }

      if (checkFileSize(file) && checkIfImage(file)) {
        formEl.current.submit();
        setUploading(false);
        return false;
      }
    } catch (error) {
      setUploading(false);
      // eslint-disable-next-line no-alert
      window.alert('something went wrong, There was a technical error.');
    }
    setUploading(false);
  };
  /* eslint-enable consistent-return */

  const handleClick = () => {
    document.body.dispatchEvent(
      new CustomEvent('dataStateChange', {
        detail: {
          action: 'global.interaction',
          type: 'search',
          subType: 'image search cta',
          additionalInfo: {},
          properties: {},
          products: {},
        },
      })
    );
  };

  // http://localhost:3001/disco-image-search
  return (
    <form
      data-testid="search-image-container"
      className={classNames(styles.imageSearchContainer)}
      method="POST"
      action="/image-search"
      encType="multipart/form-data"
      ref={formEl}
    >
      <label
        className={classNames(styles.imageSearchLabel, {
          [styles.imageSearchLabel__uploading]: uploading,
        })}
      >
        <input
          type="file"
          id="image"
          name="image"
          accept="image/*"
          onChange={uploadImage}
          data-testid="image-search-input"
          onClick={handleClick}
        />
        {uploading ? (
          <LoadingSpinner />
        ) : (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.9998 7.5H12.9998V9.20588H18.9998V7.5ZM20.9998 9.20588V7.5V5.5H18.9998H12.9998H10.9998V7.5V9.20588H6.75H4.75V11.2059V24.5V26.5H6.75H25.25H27.25V24.5V11.2059V9.20588H25.25H20.9998ZM25.25 11.2059H6.75V24.5H25.25V11.2059ZM16.0002 22.0294C18.3698 22.0294 20.2502 20.1373 20.2502 17.8529C20.2502 15.5686 18.3698 13.6765 16.0002 13.6765C13.6306 13.6765 11.7502 15.5686 11.7502 17.8529C11.7502 20.1373 13.6306 22.0294 16.0002 22.0294ZM16.0002 24.0294C19.452 24.0294 22.2502 21.2641 22.2502 17.8529C22.2502 14.4418 19.452 11.6765 16.0002 11.6765C12.5485 11.6765 9.75023 14.4418 9.75023 17.8529C9.75023 21.2641 12.5485 24.0294 16.0002 24.0294Z"
              fill="black"
            />
          </svg>
        )}
      </label>
    </form>
  );
};

export default ImageSearch;
